import React, { useEffect, useState } from 'react'

import { Admin } from '@react-admin/ra-enterprise'
import { Loading, Resource } from 'react-admin'
import { SnackbarProvider } from 'notistack'
import { createBrowserHistory as createHistory } from 'history'

import 'utils/errorReporting'

import authProvider from './authProvider'
import { CollectionList } from './components/lists/collectionList'
import { CreditLineList } from './components/lists/creditLineList'
import { InvoiceList } from './components/lists/invoiceList'
import { PaymentList } from './components/lists/paymentList'
import loginPage from './components/login/loginPage'
import logoutButton from './components/login/logoutButton'
// import RESTDataProvider from './dataProvider'
import i18nProvider from './i18nProvider'
import CollectionIcon from './images/collections'
import CollectionIconSelected from './images/collectionsSelected'
import CreditLineIcon from './images/creditLines'
import CreditLineIconSelected from './images/creditLinesSelected'
import InvoiceIcon from './images/invoices'
import InvoiceIconSelected from './images/invoicesSelected'
import PaymentIcon from './images/payments'
import PaymentIconSelected from './images/paymentsSelected'
import layout from './layout'
import NotFound from './NotFound'
import hasuraProxyDataProvider from './provider/optionalDataProvider'
import { lightTheme } from './theme'
import setSessionOrRedirect from './utils/setSessionOrRedirect'

const history = createHistory()

function App() {
  const [session, setSession] = useState(null)
  const [dataProvider, setDataProvider] = useState(null)

  useEffect(() => {
    if (!session)
      setSessionOrRedirect(setSession).then(() => {
        if (dataProvider) return

        hasuraProxyDataProvider({ setDataProvider })
      })
  }, [session])

  if (!session) return <Loading loadingPrimary={''} loadingSecondary={''} />
  if (!dataProvider)
    return <Loading loadingPrimary={''} loadingSecondary={''} />

  return (
    <SnackbarProvider maxSnack={3}>
      <Admin
        history={history}
        lightTheme={lightTheme}
        darkTheme={lightTheme}
        dataProvider={dataProvider}
        authProvider={authProvider}
        i18nProvider={i18nProvider}
        layout={layout}
        loginPage={loginPage}
        logoutButton={logoutButton}
        catchAll={NotFound}
      >
        <Resource
          name="invoices"
          options={{
            labelMenu: 'resources.invoices.labelMenu',
            label: 'resources.invoices.name',
          }}
          list={InvoiceList}
          icon={[InvoiceIcon, InvoiceIconSelected]}
        />
        <Resource
          name="payments"
          options={{
            labelMenu: 'resources.payments.labelMenu',
            label: 'resources.payments.name',
          }}
          list={PaymentList}
          icon={[PaymentIcon, PaymentIconSelected]}
        />
        <Resource
          name="collections"
          options={{
            labelMenu: 'resources.collections.labelMenu',
            label: 'resources.collections.name',
          }}
          list={CollectionList}
          icon={[CollectionIcon, CollectionIconSelected]}
        />
        <Resource
          name="creditlines"
          options={{
            labelMenu: 'resources.creditlines.labelMenu',
            label: 'resources.creditlines.name',
          }}
          list={CreditLineList}
          icon={[CreditLineIcon, CreditLineIconSelected]}
        />
      </Admin>
    </SnackbarProvider>
  )
}

export default App
